<template>
	<!-- 通过按钮 -->
	<div class="pointer plr-10 co-0066FF">
		<div @click="Operate">{{ translate.ShowText('通过') }}</div>
	</div>
</template>

<script lang="ts" setup>
import { getCurrentInstance } from 'vue';
import translate from '@/api/translate';

const { proxy } = getCurrentInstance() as any;
const emits = defineEmits(["change"]);

const Operate = () => {
	emits("change");
}
</script>

<style lang="scss" scoped></style>